import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminDashboardPage = () => {
  const [stats, setStats] = useState({ posts: null, episodes: null, inquiries: null });

  useEffect(() => {
    const opts = { withCredentials: true };
    Promise.all([
      axios.get(`${API}/admin/blog`, opts),
      axios.get(`${API}/admin/podcast`, opts),
      axios.get(`${API}/admin/inquiries`, opts),
    ]).then(([posts, episodes, inquiries]) => {
      setStats({
        posts: posts.data.length,
        episodes: episodes.data.length,
        inquiries: inquiries.data.filter((i) => i.status === "new").length,
      });
    });
  }, []);

  const cards = [
    { label: "Blog Posts", value: stats.posts, to: "/admin/blog", testId: "admin-card-blog" },
    { label: "Podcast Episodes", value: stats.episodes, to: "/admin/podcast", testId: "admin-card-podcast" },
    { label: "New Inquiries", value: stats.inquiries, to: "/admin/inquiries", testId: "admin-card-inquiries" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-disp text-3xl text-[#121212] mb-2">Welcome back.</h1>
      <p className="text-sm text-[#555555] mb-10">
        Manage the site’s writing, podcast, and inquiries from here.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {cards.map((card) => (
          <Link
            key={card.label}
            to={card.to}
            data-testid={card.testId}
            className="bg-white border border-[#e5e5e5] hover:border-[#121212] transition-colors p-8 block"
          >
            <span className="text-xs font-mono uppercase tracking-[.14em] text-[#6b6b6b] block mb-3">
              {card.label}
            </span>
            <span className="font-disp text-4xl text-[#121212]">
              {card.value === null ? "…" : card.value}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboardPage;
